import { IRoute } from 'models/route';
import APP_CONFIGURATION_ROUTES from 'modules/AppConfiguration/routes';
import AUTH_ROUTES from 'modules/Authentication/routes';
import CULTURE_CARD_ROUTES from 'modules/CultureCard/routes';
import DASHBOARD_ROUTES from 'modules/Dashboard/routes';
import END_USERS_MANAGEMENT_ROUTES from 'modules/EndUsersManagement/routes';
import LIVE_SESSION_CARDS_ROUTES from 'modules/LiveSessionCard/routes';
import MAILS_ROUTES from 'modules/Mail/routes';
import NOTIFICATIONS_ROUTES from 'modules/Notification/routes';
import REGIONS_CONFIGURATION_ROUTES from 'modules/RegionsConfiguration/routes';
import SHOP_ROUTES from 'modules/Shop/routes';
import ONBOARDING_QUESTION_ROUTES from '../modules/OnboardingQuestion/routes';
import SENTENCES_ROUTES from 'modules/Sentence/routes';
import SCENE_MATCHING_ROUTES from 'modules/SceneMatching/routes';

const GLOBAL_ROUTES: { PUBLIC: IRoute[]; PRIVATE: IRoute[] } = {
	PUBLIC: [...AUTH_ROUTES],
	PRIVATE: [
		...DASHBOARD_ROUTES,
		...ONBOARDING_QUESTION_ROUTES,
		...REGIONS_CONFIGURATION_ROUTES,
		...APP_CONFIGURATION_ROUTES,
		...CULTURE_CARD_ROUTES,
		...LIVE_SESSION_CARDS_ROUTES,
		...SHOP_ROUTES,
		...END_USERS_MANAGEMENT_ROUTES,
		...NOTIFICATIONS_ROUTES,
		...MAILS_ROUTES,
		...SENTENCES_ROUTES,
		...SCENE_MATCHING_ROUTES,
	],
};

export default GLOBAL_ROUTES;
